import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueI18n from 'vue-i18n'

Vue.use(Vuetify)
Vue.use(VueI18n)


const opts = {
    icons: {
        iconfont: 'mdi', // default - only for display purposes
      }
};

export default new Vuetify(opts)